// assets
import { BankOutlined } from '@ant-design/icons';
import { reactLocalStorage } from 'reactjs-localstorage';

// icons
const icons = {
    BankOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

let getUserInfo = reactLocalStorage.get('user_info')
getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null

const pagesExpense = {
  id: 'pages-expense',
  title: 'Pengeluaran',
  type: 'group',
  children: [
    {
      id: 'pengeluaran',
      title: 'Pengeluaran',
      type: 'item',
      url: '/expense',
      icon: icons.BankOutlined,
      breadcrumbs: true
      // target: true
    }
  ]
};

export default pagesExpense;
